import React, {useState, useCallback, useEffect, FC} from 'react'

interface IImageComponentProps extends React.ImgHTMLAttributes<HTMLImageElement> {
    errorImg?: string;
    placeHolderimg?: string;
}

/**
 * ImageComponent to handle image loading with placeholder and error handling.
 * Supports all standard img tag properties.
 *
 * @param src - Image source URL
 * @param alt - Alternate text for the image. Important for accessibility.
 * @param errorImg - Image to display on error
 * @param placeHolderimg - Placeholder image to display before the src image loads
 * @param otherProps - Other img tag properties (width, height, className, style, loading, crossOrigin, etc.)
 * @constructor
 */
const ImageComponent: FC<IImageComponentProps> = ({
    src,
    alt = '',
    errorImg = "/app-images/not-found-image/place_holder_image.png",
    placeHolderimg = "/app-images/loading/image-loader.gif",
    ...otherProps
}) => {
    const [imgSrc, setImgSrc] = useState(placeHolderimg);

    const onError = useCallback(() => {
        setImgSrc(errorImg);
    }, [errorImg]);

    useEffect(() => {
        setImgSrc(src ?? errorImg);
    }, [src, errorImg]);

    return <img {...otherProps} src={imgSrc} alt={alt} onError={onError} />;
};

export default ImageComponent;